import React from 'react';
import conferenciamujer from '../../../../../assets/icons/events/conferenciamujer.svg';
import teatro from '../../../../../assets/icons/events/Teatro.svg';
import otros from '../../../../../assets/icons/events/otros.svg';
import Exponente from '../../../../../assets/icons/events/Exponente.svg';
import Expresionesotros from '../../../../../assets/icons/events/Expresiones-otros.svg';
import Karate from '../../../../../assets/icons/events/Karate.svg';
import ajedrez from '../../../../../assets/icons/events/ajedrez.svg';
import baile from '../../../../../assets/icons/events/baile.svg';
import Box from '../../../../../assets/icons/events/Box.svg';
import campeonato from '../../../../../assets/icons/events/campeonato.svg';
import campeonatosimple from '../../../../../assets/icons/events/campeonatosimple.svg';
import Entrenamiento from '../../../../../assets/icons/events/Entrenamiento.svg';
import Manualidades from '../../../../../assets/icons/events/Manualidades.svg';
import Musicahombre from '../../../../../assets/icons/events/Musica-hombre.svg';
import Musicamujer from '../../../../../assets/icons/events/Musica-mujer.svg';
import noevents from '../../../../../assets/icons/events/noevents.svg';
import HerramientasProfesionales from '../../../../../assets/icons/events/HerramientasProfesionales.svg';

interface EventImageProps {
  image: string;
  style?: React.CSSProperties;
}

const imageMap: any = {
  'Varios-Expositores.png': otros,
  'Generica.png': otros,
  'conferencia-hombre.png': Exponente,
  'Teatro.png': teatro,
  'Expresiones-otros.png': Expresionesotros,
  'conferencia-mujer.png': conferenciamujer,
  'teatro.png': teatro,
  'Karate.png': Karate,
  'karate.png': Karate,
  'Ajedrez.png': ajedrez,
  'ajedrez.png': ajedrez,
  'Baile.png': baile,
  'baile.png': baile,
  'Box.png': Box,
  'box.png': Box,
  'Campeonato.png': campeonato,
  'campeonato.png': campeonato,
  'Campeonatosimple.png': campeonatosimple,
  'campeonatosimple.png': campeonatosimple,
  'Conferenciamujer.png': conferenciamujer,
  'Entrenamiento.png': Entrenamiento,
  'entrenamiento.png': Entrenamiento,
  'Exponente.png': Exponente,
  'exponente.png': Exponente,
  'Manualidades.png': Manualidades,
  'manualidades.png': Manualidades,
  'Musica-hombre.png': Musicahombre,
  'musica-hombre.png': Musicahombre,
  'Musica-mujer.png': Musicamujer,
  'musica-mujer.png': Musicamujer,
  'Noevents.png': noevents,
  'noevents.png': noevents,
  'otros.png': otros,
  'herramientas-profesionales.png': HerramientasProfesionales
  // terminar este listado
};

const EventImage = ({ image, style }: EventImageProps) => {
  const handleImage = () => imageMap[image] || imageMap['otros.png'];
  return <img src={handleImage()} alt="icon" style={style} />;
};

export default EventImage;
